import React from "react";
import { useNavigate, Link } from "react-router-dom";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import { Typography, Affix, Row, Col, Avatar, Space, Dropdown, Badge } from 'antd';
import { ExpandMore, VerifiedRounded, NotificationsActiveRounded } from "@mui/icons-material";
import {ExportOutlined} from "@ant-design/icons";
import CompanyLogo from "../pages/Company/CompanyLogo";
import {useSelector, useDispatch} from "react-redux";
import {selectUserFields} from "../store/slices/user.slice";
import {toggleSider} from "../store/slices/appState.slice";
import {AdvyzonRedirectUrl} from "../configs/Domain";
import {selectPortfoliosWithSignals} from "../store/slices/portfolios.slice";

const CompanyNavigator = ({company})=>{
    const navigate = useNavigate();
    return (
        <Space direction={'vertical'}>
            <Typography.Text strong onClick={()=>navigate('/company/details/edit')}>
                {company?.company_name}
            </Typography.Text>
            <Typography.Link>{company?.website_url} <ExportOutlined style={{paddingLeft: 2}} /></Typography.Link>
        </Space>
    )
}



const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const siderVisible = useSelector((state) => state.appStates.siderVisible);
  const settings = useSelector((state) =>
        selectUserFields(state, "settings")
  );
  const portfolios = useSelector(selectPortfoliosWithSignals);

  const company = useSelector((state) =>
    selectUserFields(state, "company_details")
  );
  const username = settings?.display_name
  const cid = company?.cid;
  const companyBrandUrl = company?.logo_url;


  const handleNavigate = (route) => {
    navigate(route);
  }

  const menuItems = [
    {
      key: 'touchpoints',
      label: "Touchpoints",
      onClick: ()=>handleNavigate('/beta/touchpoints')
    },
    {
        key: 'compare',
        label: 'Comparison v2 (BETA)',
        onClick: () => handleNavigate('/beta/comparison')
    },
      {
        key: 'interactiveRisk',
        label: 'Interactive Risk',
        onClick: () => handleNavigate('/beta/interactive-risk')
      },
      {
          key: 'experimental',
          label: "Experiments",
          onClick: ()=>handleNavigate('/experiments/home')
      },
      {
          key: 'factors',
          label: "Factor View",
          onClick: ()=>handleNavigate('/markets/factors')

      },
      {
          key: "Xray",
            label: "Xray",
            onClick: ()=>handleNavigate('/beta/xray')
      }

  ];

  return (
      <Affix offsetTop={0}>
          <Row justify={'space-between'} align={'middle'} gutter={16} className={'px-6 py-1 header-row-main'}   style={{
            position: 'relative',
            zIndex: 10,
            background: 'var(--primary)',
          }} >
              <Col>
                  <Row justify={'space-between px-3'} align={'middle'} gutter={16}>
                      <Col>
                          {cid && <CompanyLogo imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/finiat-white.png'}
                                               companyId={cid}
                                               editable={false}
                                               size={'small'}
                          />}
                      </Col>
                  </Row>
              </Col>
              <Col>
                  <Row align={'middle'} gutter={32}>
                      {/*<Col>*/}
                      {/*    <IconButton onClick={() =>  window.open(AdvyzonRedirectUrl)}>*/}
                      {/*        <img*/}
                      {/*          src={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/advyzon-transparent.png'}*/}
                      {/*          alt="Custom Icon"*/}
                      {/*          style={{ width: "70px", height: "45px", borderRadius: "4px" }}  // Adjust size and style as needed*/}
                      {/*        />*/}
                      {/*      </IconButton>*/}
                      {/*</Col>*/}
                      <Col>
                          <ButtonGroup>
                              <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                                <Button sx={{color: "#fff"}} variant={'text'} color={'primary'} endIcon={<ExpandMore/>}>Preview</Button>
                              </Dropdown>
                          </ButtonGroup>
                      </Col>
                      <Col style={{paddingRight: '30px'}}>
                          <Row align={'middle'} justify={'start'} gutter={8}>
                              <Col>
                                  <Avatar size={'default'} style={{ background: 'linear-gradient(to bottom right,#000ca4,#505dff)' }}>
                                  {username && username.slice(0, 1).toUpperCase()}
                                  </Avatar>
                              </Col>
                              <Col>
                                  <Typography.Text ellipsis={true} style={{
                                      fontSize: '1.1rem',
                                      color: "#fff",
                                      fontWeight: '200',
                                      fontFamily: "Inter, sans-serif"
                                  }}
                                               onClick={() => handleNavigate('/settings')}>
                                      {username} | {company?.company_name}
                                  </Typography.Text>
                              </Col>
                          </Row>
                      </Col>


                  </Row>
              </Col>
          </Row>
      </Affix>

  );
};

export default Header;